import { createAction } from 'redux-actions';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const loginSuccess = createAction(LOGIN_SUCCESS, data => data);
